module.exports = __webpack_public_path__ + "static/media/rectangle.bb38b049.svg";